import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { avatarColor, formatClock, initialsOf, TranscriptLine } from "../meeting-room/meeting-utils";

@Component({
  selector: "app-meeting-transcript",
  standalone: false,
  templateUrl: "./meeting-transcript.component.html",
  styleUrls: ["./meeting-transcript.component.scss"],
})
export class MeetingTranscriptComponent implements OnChanges, AfterViewInit {
  @Input() lines: TranscriptLine[] = [];
  @Input() partial: { speaker: string; speakerId: string; text: string } | null = null;
  @Input() enabled = false;
  @Input() notice = "";
  @ViewChild("body") body?: ElementRef<HTMLDivElement>;
  private stickToBottom = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes["lines"] || changes["partial"]) this.scroll(false);
  }

  ngAfterViewInit() {
    this.scroll(true);
  }

  startsGroup(index: number): boolean {
    return index === 0 || this.lines[index - 1].speakerId !== this.lines[index].speakerId;
  }

  initials(name: string): string {
    return initialsOf(name);
  }

  color(seed: string) {
    return avatarColor(seed);
  }

  clock(at: number): string {
    return formatClock(at);
  }

  trackLine(_: number, line: TranscriptLine) {
    return line.id;
  }

  onScroll() {
    const el = this.body?.nativeElement;
    if (!el) return;
    this.stickToBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 48;
  }

  private scroll(force: boolean) {
    if (!force && !this.stickToBottom) return;
    setTimeout(() => {
      const el = this.body?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    });
  }
}
